import { Entity, Column, PrimaryGeneratedColumn, OneToOne, JoinColumn } from 'typeorm'

import Response from './Response'

@Entity('response_metadata')
export default class ResponseMetaData {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @OneToOne(type => Response, response => response.metaData)
  @JoinColumn({ name: 'response_id' })
  response!: Response

  @Column({ name: 'response_id' })
  responseId!: string

  @Column({ name: 'uset_embedding', type: 'jsonb', array: false })
  usetEmbedding!: Number[]

  @Column({ name: 'workspace_id' })
  workspaceId!: string

  @Column({ name: 'test_id' })
  testId!: string

  @Column({ name: 'uset_version' })
  usetVersion!: string

  @Column({ name: 'created_at' })
  createdAt!: Date
}
